import React, { Component } from 'react'
import axios from 'axios';
import withTracker from "../containers/Full/withTracker";
import {Redirect, withRouter} from "react-router-dom";
import {connect} from "react-redux";


import '../styles/requestForm.css';
import {request} from '../modules/actions/request';
import Swal from "sweetalert2";

class RequestForm extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            date: this.props.selectedDate,
            sellerId: this.props.sellerId,
        };
    }

    handleChange(event){
        let values = this.state;
        // console.log('values ', values);
        // console.log(event.target.name);
        values[event.target.name] = event.target.value;
        this.setState(values);
        // console.log(values, this.state);
    }

    async submitRequest(){
        let result = await this.props.dispatch(request(this.state)); //dispatch is promise so need async
        // console.log("what is request??", result);
        console.log("submit OK?");
        if(this.props.selectedDate){
            if(result.status==="Success"){
                Swal.fire({
                    title: 'Success!',
                    text: 'Your request is sent successfully.',
                    type: 'success',
                    confirmButtonText: 'close'
                })
                    .then(()=>{
                        console.log("Dismissed");
                        console.log("what happened");
                        window.location.assign('/dashboard/profile/'+this.props.sellerName);
                    });
            } else {
                console.log("I'm confused");
            }
        } else {
            Swal.fire({
                title: 'Error',
                text: 'Select the date.',
                type: 'error',
                confirmButtonText: 'close'
            })

        }
    }

    render() {
        console.log("REQUEST This state", this.props);
        return (
            <div className="popup">
                <div className="popup_inner">
                    <div className="request-title">
                        Request to {this.props.sellerName}
                    </div>
                    <form style={{ marginTop: '10px', height: '80%' }}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6" style={{ display: 'flex' }}>
                                    <div>
                                        <strong>Date: </strong>
                                        {/*<input type="date" name="date" placeholder="date" style={{ width: '100%' }} />*/}
                                        <div> {this.props.selectedDate ? this.props.selectedDate.slice(0,15): "Please select date."} </div>
                                    </div>
                                </div>
                                <div className="col-6" style={{ display: 'flex' }}>
                                    <div>
                                        <strong>Topic: </strong>
                                        <div> {this.props.topic} </div>
                                    </div>
                                </div>
                            </div>
                            <br />

                            <strong>Subject: </strong>
                            <br />
                            <input type="text" name="subject" id="subject" placeholder="subject" style={{ width: '100%' }}
                            onChange={this.handleChange.bind(this)}/>
                            <br />
                            <br />
                            <strong>Personal Message:</strong>
                            <br />
                            <textarea
                                name="message" id="message"
                                placeholder="Explain your interest with personal message"
                                style={{ width: '100%', height: '15vh' }}
                                onChange={this.handleChange.bind(this)}
                            />
                        </div>
                        {/*<div className="form-button">*/}
                        {/*    <button className="submit-button"*/}
                        {/*            onClick={this.submitRequest.bind(this)}>*/}
                        {/*        Submit*/}
                        {/*    </button>*/}
                        {/*    <button className="cancel-button"*/}
                        {/*        onClick={this.props.closeForm}>*/}
                        {/*        Close*/}
                        {/*    </button>*/}
                        {/*</div>*/}
                    </form>
                    <div className="form-button">
                        <button className="submit-button"
                                onClick={this.submitRequest.bind(this)}>
                            Submit
                        </button>
                        <button className="cancel-button"
                                onClick={this.props.closeForm}>
                            Close
                        </button>
                    </div>
                    {/*<div className="container">*/}
                    {/*    <button style={{ backgroundColor: '#c6a676', color: 'white', border: 'none' }}*/}
                    {/*    onClick={this.submitRequest.bind(this)}>*/}
                    {/*        Submit*/}
                    {/*    </button>*/}
                    {/*    <button onClick={this.props.closeForm} style={{ float: 'right' }}>*/}
                    {/*        Close*/}
                    {/*    </button>*/}
                    {/*</div>*/}
                </div>
            </div>
        )
    }
}

function mapStateToProps(store){
    return {
    };
}

export default withRouter(connect(mapStateToProps)(RequestForm));
